// @flow

import React from 'react';
import { connect } from 'react-redux';
import Gallery from '../gallery';
import { getImages, getDefaultImage } from '../../store/pdb';
import { getDisclaimerText } from '../../store/componentSettings/selectors/pdbGallerySettings';
import type { Image } from '../../types/pdb';

type StateProps = {|
  images: ?Image[],
  disclaimerText: string,
  defaultImage: ?Image,
|};

type OwnProps = {|
  boxed: boolean,
  videoSrc?: ?string,
  videoPosition?: ?string,
  videoTitle?: ?string,
  showDisclaimer: boolean,
|};

type Props = OwnProps & StateProps;

const PdbGallery = ({
  boxed,
  defaultImage,
  disclaimerText,
  images,
  showDisclaimer,
  videoPosition,
  videoSrc,
  videoTitle,
}: Props) => {
  let galleryImages = [];

  if (images && images.length !== 0) {
    galleryImages = [...images];
  }

  if (defaultImage) {
    galleryImages.unshift(defaultImage);
  }

  return (
    <Gallery
      boxed={boxed}
      images={galleryImages}
      showDisclaimer={showDisclaimer}
      disclaimerText={disclaimerText}
      videoSrc={videoSrc}
      videoPosition={videoPosition}
      videoTitle={videoTitle}
    />
  );
};

PdbGallery.defaultProps = {
  videoSrc: null,
  videoPosition: 'second',
  videoTitle: '',
};

const mapStateToProps = (state): StateProps => ({
  defaultImage: getDefaultImage(state),
  disclaimerText: getDisclaimerText(state),
  images: getImages(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(PdbGallery);
